import "./ProfilePartners.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfilePartnersComponentController from "./ProfilePartnersComponentController";

export default class ProfilePartnersComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfilePartnersComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Partners/ProfilePartners.html";
    }
}

module("mmAuth").component("mmProfilePartners", new ProfilePartnersComponent());
